// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirmation_wrapper__yFEUo","confirmation":"Confirmation_confirmation__Njugw","textBlock":"Confirmation_textBlock__RAbu7","buttons":"Confirmation_buttons__6TZ3z"};